import React from "react";
import { useDashboardStats } from "@/hooks/useDashboardStats";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { PageHeader, StatCard } from "@/components/common/DashboardBits";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { ClipboardList, Users } from "lucide-react";

export default function OfficeOverview() {
  const { user } = useAuth();
  const { t } = useLang();
  const stats = useDashboardStats();
  return (
    <div>
      <PageHeader title={`${t("welcome_back")}, ${user?.name || ""}`} subtitle="Coordinate visits & submit valuations" />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
        <StatCard testId="stat-total" label={t("total_leads")} value={stats?.total_leads ?? "—"} />
        <StatCard testId="stat-pending" label={t("pending")} value={stats?.pending ?? 0} tone="amber" />
        <StatCard testId="stat-in-progress" label={t("in_progress")} value={stats?.in_progress ?? 0} tone="blue" />
        <StatCard testId="stat-visited" label={t("visited")} value={stats?.visited ?? 0} tone="green" />
        <StatCard testId="stat-submitted" label={t("submitted")} value={stats?.submitted ?? 0} tone="green" />
      </div>
      <Card className="border border-slate-200 max-w-2xl">
        <CardContent className="p-6">
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500">Quick actions</div>
          <div className="mt-4 flex flex-wrap gap-3">
            <Link to="/office/leads" className="inline-flex items-center gap-2 px-4 py-2 bg-slate-950 hover:bg-slate-800 text-white rounded-md text-sm">
              <ClipboardList className="h-4 w-4" /> All Leads
            </Link>
            <Link to="/office/executives" className="inline-flex items-center gap-2 px-4 py-2 border border-slate-300 hover:bg-slate-50 rounded-md text-sm">
              <Users className="h-4 w-4" /> Field Executives
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
